export class Provincia {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public codigo: string | undefined;
    public nombre: string | undefined;
    public comunidadAutonoma: string | undefined;
}